import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import Button from '@material-ui/core/Button';
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTable from "./BasicTable";
import { Dialog, DialogContent } from '@material-ui/core';
import { apiurl } from '../app/prefs.js';
import MonthSelect from "./MonthSelection";
import FilterWindow from "./FilterWindow";

export default function Report024() {
  const [totalData, setTotalData] = React.useState([]);
  const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
  const [totalDataComplete, setTotalDataComplete] = React.useState(false);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const [selectedMonths, setSelectedMonths] = React.useState([]);
  const [opkList, setOpkList] = React.useState([]);
  const [exportDialogOpen, setExportDialogOpen] = React.useState(false);

  const [selectedOPK, setSelectedOPK] = React.useState(undefined);

  const downloadFile = (downloadURL) => {

    getAccessTokenSilently().then((token) => {
      document.body.style.cursor = 'wait';
      const apiUrl = downloadURL
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `AOTM_FK_OPK.xlsx`,
          );
          // Append to html link element page
          document.body.appendChild(link);
          // Start download
          link.click();
          // Clean up and remove the link
          link.parentNode.removeChild(link);
          document.body.style.cursor = 'auto';
          setExportDialogOpen(false);
        });
    });

  };

  const downloadMulti = (list) => {
    //alert(list);
    downloadFile(`${apiurl}/aotmit/fk_opk/${JSON.stringify(list)}/${startDate.year}/${JSON.stringify(selectedMonths)}/multixlsx`);
  };

  function DateBox(props) {
    return (
      <Autocomplete
        id="combo-box"
        options={dateList}
        value={startDate}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option && option.year.toLocaleString()}
        defaultValue={null}
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.year.toLocaleString() === value.year.toLocaleString();
        }}
        style={{ width: "80px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Rok" />}
        onChange={(event, value) => {
          if (value) {
            setStartDate(value);
            loadData(selectedOPK, value.year, selectedMonths);
          }
        }}
      />
    );
  }

  function OpkBox() {
    return (
      <Autocomplete
        id="opk-combo-box"
        options={opkList}
        value={selectedOPK}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option && (option.opk_id + ' - ' + option.opk_name)}
        defaultValue={null}
        placeholder='Wybierz OPK'
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.opk_name === value.opk_name;
        }}
        style={{ width: "380px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="OPK" />}
        onChange={(event, value) => {
          if (value) {
            setSelectedOPK(value);
            loadData(value.opk_id, startDate.year, selectedMonths);
          }
        }}
      />
    );
  }

  function loadDataBasic(year, months) {
    loadData(selectedOPK.opk_id, year, months)
  }

  const loadData = (opk, year, months) => {
    setTotalDataLoaded(false);
    setTotalDataComplete(false);
    //const apiUrl = `${apiurl}/salariesreport/${opk}/${groups}/${accounts}/${contracts}/${year}/${JSON.stringify(months)}`;
    const apiUrl = `${apiurl}/aotmit/fk_opk/${opk}/${year}/${JSON.stringify(months)}`
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setTotalData(fetchedData);
          if (
            fetchedData.meta && fetchedData.data && Array.isArray(fetchedData.data)
          ) setTotalDataComplete(true);
          setTotalDataLoaded(true);
        });
    });
  }

  const loadFilters = () => {
    setFiltersLoaded(false);
    const apiUrl = `${apiurl}/salariesreport`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setDateList(fetchedData.YEARS);
          if (fetchedData.YEARS && fetchedData.YEARS.length !== 0) {
            setStartDate(fetchedData.YEARS[fetchedData.YEARS.length - 1]);
            setOpkList([
              ...fetchedData.OPK_LIST
            ]);
            setFiltersLoaded(true);
          }
        });
    });
  }

  React.useEffect(() => {
    let mounted = true;
    //console.log("Main mounted");
    if (mounted) loadFilters();
    return function cleanup() {
      //console.log("Main unmounted");
      mounted = false;
    };
  }, []);

  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #9BC0C5)",
          display: "flex",
          height: "55px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Zestawienie AOTMiT FK.OPK
          </Typography>
        </div>
      </div>
      <p style={{ height: "5px" }} />
      {filtersLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
          }}
        >
          <OpkBox />
          <DateBox data={dateList} />
          <MonthSelect setSelectedMonthsFunction={setSelectedMonths} loadDataFunction={loadDataBasic} selectedMonthsProperty={selectedMonths} startDateProperty={startDate} />

          <div style={{ position: "absolute", right: "15px" }}>

            <Button
              style={{ backgroundColor: 'lightgray', marginRight: '5px' }}
              disabled={selectedOPK === undefined ? true : false}
              onClick={
                () => downloadFile(`${apiurl}/aotmit/fk_opk/${selectedOPK.opk_id}/${startDate.year}/${JSON.stringify(selectedMonths)}/xlsx`)
              }
            >

              Pobierz wybrany OPK
            </Button>

            <Button style={{ backgroundColor: 'lightgray ' }}
              onClick={
                () => setExportDialogOpen(true)
              }
            >
              <sup style={{ color: '#FE8E3C', fontWeight: "bold", fontSize: '16px', marginTop: '-15px' }} > N </sup>
              Pobierz wiele OPK
            </Button>

          </div>

        </div>
      ) : (
        <div>Wczytywanie danych</div>
      )}
      <p style={{ height: "5px" }} />

      {selectedOPK && totalDataComplete ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: totalDataLoaded ? "1" : "0.2",
          }}
        >
          <div
            id="top chart area"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <div
              id="left chart area"
              style={{
                display: "flex",
                flexWrap: "wrap",
                //maxWidth: "840px",
                width: "100%",
                flexDirection: "column",
                flexShrink: 1,
              }}
            >

              <div
                id="top 3 bottom 3 tables area"
                style={{
                  display: "flex",
                  paddingRight: "0px",
                  alignItems: "stretch",
                  flexWrap: "wrap",
                  width: "100%",
                  flexDirection: "row",
                  flexGrow: 1,
                  flexShrink: 1,
                }}
              >
                <BasicTable data={totalData} />

              </div>
            </div>
          </div>
        </div>
      ) : (
        !selectedOPK && (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left"
            }}
            variant="h5"
          >
            Wybierz OPK
          </Typography>
        )
      )}
      {(!totalDataLoaded && selectedOPK) && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: totalData[0] ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={exportDialogOpen}
        onClose={() => setExportDialogOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        //style={{ zIndex: 10000, height: "100%" }}
        style={{ height: "70%" }}
      >
        <Typography
          variant="h6"
          style={{ color: "#0b6471", marginLeft: "30px", marginTop: "10px" }}
        >
          {`Wybierz OPK do wyeksportowania`}
        </Typography>
        <DialogContent>
          <FilterWindow
            closeFn={setExportDialogOpen}
            downloadFn={downloadMulti}
            lookupPlaceholder='Wpisz fragment kodu OPK, którego szukasz' list
            ={opkList.map(i => { return { id: i.opk_id, name: i.opk_name } })} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
